import { TaskTypeDetailedDTO2 } from '../api/api';

// A preparation task type points at its main task type, so the main task finds it by looking the other way.
// It is expected to be 1:1 - if more than one points at the same main task type, the first one is used.
const findPreparationTaskType = (taskType: TaskTypeDetailedDTO2, taskTypes: TaskTypeDetailedDTO2[]) =>
  taskTypes.find((t) => t.isPreparationTask && !t.isDisabled && t.mainTaskId === taskType.id);

/**
 * The task type a relational task is created with after creating a task of the given type.
 * A preparation task type pointing at it wins, otherwise the default relational task type set on the type itself.
 */
export const getRelationalTaskType = (
  taskType: TaskTypeDetailedDTO2 | undefined,
  taskTypes: TaskTypeDetailedDTO2[]
): TaskTypeDetailedDTO2 | undefined => {
  if (!taskType) return undefined;

  return (
    findPreparationTaskType(taskType, taskTypes) ??
    taskTypes.find((t) => t.id !== undefined && t.id === taskType.defaultRelationalTaskTypeId)
  );
};

/**
 * Whether "Opret relationsopgave" starts out checked for a task of the given type.
 */
export const shouldAutoCreateRelationalTask = (
  taskType: TaskTypeDetailedDTO2 | undefined,
  taskTypes: TaskTypeDetailedDTO2[]
): boolean => {
  if (!taskType) return false;

  return !!taskType.requiresPreparationTask || !!findPreparationTaskType(taskType, taskTypes);
};
